import { InlineNotification } from "@carbon/react";
import { useTranslation } from "react-i18next";
import { formatBiddingDateTime } from "../../utils/biddingTime";

type Props = {
  closesAt?: string | null;
  finishDate?: string | null;
};

/** "La cotización cerró el 20/10/2026 18:00" — shown where a supplier would otherwise quote. */
const ClosedBiddingNotice = ({ closesAt, finishDate }: Props) => {
  const { t } = useTranslation();
  const when = formatBiddingDateTime(closesAt, finishDate);
  return (
    <InlineNotification
      kind="warning"
      lowContrast
      hideCloseButton
      title={when ? t("offer.closedAt", { date: when }) : t("offer.closed")}
    />
  );
};

export default ClosedBiddingNotice;
